/* Vaste balk onderaan de productpagina: verschijnt zodra de bestelknop uit beeld is gescrold. Zoekt elementen steeds opnieuw op. */
(function () {
  if (window.lloStickyReady) return;
  window.lloStickyReady = true;

  var raf = 0;

  function update() {
    raf = 0;
    var bars = document.querySelectorAll('[data-llo-stickybar]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var root = bar.closest('[data-llo]');
      var ref = root && (root.querySelector('.llo__atc') || root.querySelector('.llo__boxed'));
      var show = ref ? ref.getBoundingClientRect().bottom < 0 : (window.pageYOffset || 0) > 600;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }

  function queue() {
    if (!raf) raf = requestAnimationFrame(update);
  }

  document.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('resize', queue);
  document.addEventListener('shopify:section:load', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
})();
